import api from './api.js'

class AuthService {
  
  // OAuth 인증 URL 가져오기
  async getOAuthUrl(provider) {
    try {
      const redirectUri = `${window.location.origin}/auth/callback`
      const response = await api.get(`/auth/oauth/${provider}/url`, {
        params: { redirectUri }
      })
      return response.data.authUrl
    } catch (error) {
      console.error(`${provider} OAuth URL 가져오기 실패:`, error)
      throw error
    }
  }

  // OAuth 콜백 처리
  async handleOAuthCallback(provider, accessToken) {
    try {
      const response = await api.post('/auth/oauth/callback', {
        provider,
        accessToken
      })
      return response.data
    } catch (error) {
      console.error('OAuth 콜백 처리 실패:', error)
      throw error
    }
  }

  // OAuth 토큰 교환 (AuthCallback.vue에서 사용)
  async exchangeToken(provider, code) {
    try {
      const response = await api.post(`/auth/oauth/${provider}/callback`, {
        code
      })
      return response.data
    } catch (error) {
      console.error('OAuth 토큰 교환 실패:', error)
      throw error
    }
  }

  // 기존 세션 확인
  async checkExistingSessions(email) {
    try {
      const response = await api.post('/auth/check-existing-sessions', {
        email
      })
      return response.data
    } catch (error) {
      console.error('기존 세션 확인 실패:', error)
      throw error
    }
  }

  // 일반 로그인
  async login(email, password) {
    try {
      const response = await api.post('/auth/login', {
        email,
        password
      })
      return response.data
    } catch (error) {
      console.error('로그인 실패:', error)
      throw error
    }
  }

  // 강제 로그인 (기존 세션 종료)
  async forceLogin(email, password) {
    try {
      const response = await api.post('/auth/force-login', {
        email,
        password
      })
      return response.data
    } catch (error) {
      console.error('강제 로그인 실패:', error)
      throw error
    }
  }

  // 로그아웃
  async logout() {
    try {
      const response = await api.post('/auth/logout')
      return response.data
    } catch (error) {
      console.error('로그아웃 API 호출 실패:', error)
      // 로그아웃 API 실패해도 클라이언트 로그아웃은 진행
      throw error
    }
  }

  // 전체 기기 로그아웃
  async logoutAll() {
    try {
      const response = await api.post('/auth/logout-all')
      return response.data
    } catch (error) {
      console.error('전체 로그아웃 API 호출 실패:', error)
      throw error
    }
  }

  // 회원가입
  async register(userData) {
    try {
      const response = await api.post('/auth/register', userData)
      return response.data
    } catch (error) {
      console.error('회원가입 실패:', error)
      throw error
    }
  }

  // JWT 토큰 저장
  setToken(token) {
    if (token) {
      localStorage.setItem('ttaechang_token', token)
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    } else {
      this.removeToken()
    }
  }

  // JWT 토큰 가져오기
  getToken() {
    return localStorage.getItem('ttaechang_token')
  }

  // JWT 토큰 제거
  removeToken() {
    localStorage.removeItem('ttaechang_token')
    delete api.defaults.headers.common['Authorization']
  }

  // 동시접속자 수 조회
  async getOnlineUsersCount() {
    try {
      const response = await api.get('/auth/online-users-count')
      return response.data
    } catch (error) {
      console.error('동시접속자 수 조회 실패:', error)
      throw error
    }
  }

  // 토큰 초기화 (앱 시작 시)
  initializeAuth() {
    const token = this.getToken()
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    }
  }
}

export const authService = new AuthService()